// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__E4Mh1","costSection":"styles_costSection__tilw_","totalSummary":"styles_totalSummary__sKQTt","preferredDatesList":"styles_preferredDatesList__ss9r_"};